module.exports = __webpack_public_path__ + "img/empty-list.d1575cc8.svg";